export default class BaseContainer extends Phaser.GameObjects.Container {

    constructor(scene, x, y) {
        super(scene, x, y)

        this.crumbs = scene.crumbs
        this.network = scene.network
        this.soundManager = scene.soundManager

        this.interface = scene.interface
        this.memory = scene.memory
        this.ruffle = scene.ruffle
        this.world = scene.world
    }

    getString(...args) {
        return this.scene.getString(...args)
    }

    getFormatString(id, ...args) {
        return this.scene.getFormatString(id, ...args)
    }

    show() {
        this.visible = true
    }

    close() {
        this.visible = false
    }
    
    /**
     * Play a UI sound effect (CPI-style)
     * @param {string} key - Sound key (CPI naming: ui-button-click, ui-tray-open, etc.)
     * @param {number} volume - Volume (0-1)
     */
    playSfx(key, volume = 0.35) {
        try {
            if (this.soundManager && this.scene.cache.audio.exists(key)) {
                this.soundManager.playSfx(key, { volume, allowOverlap: true })
            }
        } catch (e) {
            // Silently fail if sound system not available
        }
    }

}
